<app-first-step-candidat
  *ngIf="step == 2"
  [form]="firstStepForm"
  (onSubmit)="onSubmit.emit()"
>
</app-first-step-candidat>

<app-second-step-candidat
  *ngIf="step == 3"
  [form]="secondStepForm"
  (onSubmit)="onSubmit.emit()"
>
</app-second-step-candidat>

<app-third-step-candidat
  *ngIf="step == 4"
  [form]="thirdStepForm"
  [firstStepForm]="firstStepForm"
  [loading]="loading"
  (onSubmit)="submit()"
>
</app-third-step-candidat>
